document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
        const pricingSwiper = new Swiper('.best-seler-swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            grabCursor: true,
            navigation: {
                nextEl: '.best-seler-next',
                prevEl: '.best-seler-prev',
            },
            breakpoints: {
                800: {
                    slidesPerView: 1,
                },
                900: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }/* ,
                1400: {
                    slidesPerView: 4,
                }, */
            },
        });
    }
});